import urljoin from 'url-join';
import { portalApi } from './index.api';

/** Admin pipeline record reads; canonical prefix matches PortalApi (legacy `pipeline-tracker` remains as server alias). */
const PIPELINE_STATUS_ADMIN = 'pipeline-status';

/**
 * Append query param if value is non-empty (strings) or defined (numbers/dates).
 * @param {URLSearchParams} sp
 * @param {string} key
 * @param {unknown} val
 */
function appendParam(sp, key, val) {
	if (val === undefined || val === null) return;
	if (typeof val === 'string' && val.trim() === '') return;
	sp.append(key, String(val));
}

/**
 * GET /api/v1/pipeline-status/records — admin pipeline status explorer (paged, filtered). Alias: …/pipeline-tracker/records.
 * Response: { items, totalCount, skip, take } (camelCase from API).
 */
export const pipelineStatusApi = portalApi.injectEndpoints({
	endpoints: (builder) => ({
		pipelineStatusRecords: builder.query({
			query: (arg = {}) => {
				const sp = new URLSearchParams();
				appendParam(sp, 'scope', arg.scope);
				appendParam(sp, 'subjectId', arg.subjectId);
				appendParam(sp, 'parentWorkflow', arg.parentWorkflow);
				appendParam(sp, 'parentSubjectId', arg.parentSubjectId);
				appendParam(sp, 'workflow', arg.workflow);
				appendParam(sp, 'pipeline', arg.pipeline);
				appendParam(sp, 'stage', arg.stage);
				appendParam(sp, 'status', arg.status);
				appendParam(sp, 'source', arg.source);
				appendParam(sp, 'correlationId', arg.correlationId);
				appendParam(sp, 'occurredAfter', arg.occurredAfter);
				appendParam(sp, 'occurredBefore', arg.occurredBefore);
				const skip = arg.skip ?? 0;
				const pageSize = arg.page_size ?? 100;
				sp.append('skip', String(skip));
				sp.append('page_size', String(pageSize));
				const qs = sp.toString();
				const base = urljoin(PIPELINE_STATUS_ADMIN, 'records');
				return {
					url: qs ? `${base}?${qs}` : base,
					method: 'GET',
				};
			},
			providesTags: ['pipelineStatusRecords'],
		}),
		/**
		 * GET /api/v1/pipeline-status/activity — recent pipeline facts (admin). Polling-friendly; keep cache minimal. Alias: …/pipeline-tracker/activity.
		 */
		pipelineStatusActivity: builder.query({
			query: (arg = {}) => {
				const sp = new URLSearchParams();
				appendParam(sp, 'status', arg.status);
				appendParam(sp, 'workflow', arg.workflow);
				if (arg.minutes != null && arg.minutes > 0) {
					sp.append('minutes', String(arg.minutes));
				}
				const take = arg.take ?? 20;
				sp.append('take', String(take));
				const qs = sp.toString();
				const base = urljoin(PIPELINE_STATUS_ADMIN, 'activity');
				return {
					url: qs ? `${base}?${qs}` : base,
					method: 'GET',
				};
			},
			providesTags: ['pipelineStatusActivity'],
			keepUnusedDataFor: 0,
		}),
	}),
});

export const { usePipelineStatusRecordsQuery, usePipelineStatusActivityQuery } = pipelineStatusApi;
